export default "__VITE_ASSET__Dte2lZlX__"